// extracted by mini-css-extract-plugin
module.exports = {"product-name-column":"product-name-column___35Z8p"};